import React, { useState, useEffect, useCallback, memo } from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import IvrTreeContext from './ivrTreeContext';
import { OPTION_NODE_TYPE, START_NODE_ID } from 'src/presentation/components/pages/ivr/constants/ivrTreeConstants';
import { RootTree } from './components/ivrRootTree';
import { SvgContainer } from './ivrTreeLayout';

type IvrTreeProps = {
  filter: string;
  hideTree: boolean;
  ivrFrameSize: any;
  nodeSelected?: Function;
  optionNodeSelected?: Function;
  readOnly?: boolean;
  treeData: any;
};

const IvrTree = ({
  filter,
  hideTree,
  ivrFrameSize,
  nodeSelected,
  optionNodeSelected,
  readOnly,
  treeData,
}: IvrTreeProps) => {
  const [frameSize, setFrameSize] = useState(ivrFrameSize);
  const [selectedNodeId, setSelectedNodeId] = useState('');
  const [toNode, setToNode] = useState();
  const [treeNodesData, setNodesTreeData] = useState(treeData);

  useEffect(() => {
    if (!isEmpty(treeData.tree)) {
      setNodesTreeData(treeData);
      setFrameSize(ivrFrameSize);
    }
  }, [treeData, ivrFrameSize, setNodesTreeData, setFrameSize]);

  useEffect(() => {
    let nodeId = filter;
    if (typeof filter === 'object') {
      nodeId = get(filter, 'data.id', '');
    }

    const selectedNode: any = treeNodesData.findNodeById(nodeId || START_NODE_ID);
    const selectedNodeId: any = !filter ? selectedNode.id : nodeId;

    if (selectedNodeId) {
      setSelectedNodeId(selectedNodeId);
      setToNode(selectedNode);
    }
  }, [filter, treeNodesData, selectedNodeId]);

  const nodeClick = useCallback(
    node => {
      setSelectedNodeId(node.id);
      if (node.type === OPTION_NODE_TYPE) {
        optionNodeSelected && optionNodeSelected({ parentNodeId: node.parent, data: node.data });
      } else {
        nodeSelected && nodeSelected(node.id);
      }
    },
    [optionNodeSelected, nodeSelected]
  );

  const context = { toNode, selectedNodeId, nodeClick, ivrFrameSize: frameSize, hideTree };

  return (
    <React.Fragment>
      <IvrTreeContext.Provider value={context}>
        <SvgContainer width={frameSize.width} height={frameSize.height} readOnly={readOnly}>
          {!hideTree && <RootTree className="rootTree" treeData={treeNodesData} />}
        </SvgContainer>
      </IvrTreeContext.Provider>
    </React.Fragment>
  );
};

export default memo(IvrTree);
